import React from 'react';
import { TextField, alpha } from '@mui/material';
import { COLORS, FONT_SIZES, FONT_WEIGHTS } from '../../theme/constants';

/**
 * StyledTextField - A modern, polished TextField with consistent styling
 * Features: Focus glow, smooth transitions, custom placeholder
 */
const StyledTextField = ({
  sx = {},
  size = 'small',
  variant = 'outlined',
  ...props
}) => {
  return (
    <TextField
      size={size}
      variant={variant}
      sx={{
        '& .MuiOutlinedInput-root': {
          backgroundColor: COLORS.background.paper,
          fontSize: FONT_SIZES.body1,
          transition: 'all 0.2s ease',
          
          '& fieldset': {
            borderColor: COLORS.border.light,
            borderWidth: 1.5,
            transition: 'all 0.2s ease',
          },
          
          '&:hover': {
            '& fieldset': {
              borderColor: COLORS.border.main,
            },
          },
          
          '&.Mui-focused': {
            boxShadow: `0 0 0 3px ${alpha(COLORS.primary.main, 0.12)}`,
            '& fieldset': {
              borderColor: COLORS.primary.main,
              borderWidth: 2,
            },
          },
          
          '&.Mui-error': {
            '& fieldset': {
              borderColor: COLORS.error.main,
            },
            '&.Mui-focused': {
              boxShadow: `0 0 0 3px ${alpha(COLORS.error.main, 0.12)}`,
            },
          },
          
          '&.Mui-disabled': {
            backgroundColor: COLORS.background.default,
            '& fieldset': {
              borderColor: COLORS.border.light,
            },
          },
        },
        
        '& .MuiInputLabel-root': {
          fontSize: FONT_SIZES.body2,
          color: COLORS.text.secondary,
          fontWeight: FONT_WEIGHTS.medium,
          
          '&.Mui-focused': {
            color: COLORS.primary.main,
          },
          
          '&.Mui-error': {
            color: COLORS.error.main,
          },
        },
        
        '& .MuiFormHelperText-root': {
          fontSize: FONT_SIZES.caption,
          marginLeft: 0,
          marginTop: 0.5,
        },
        
        '& .MuiInputBase-input': {
          '&::placeholder': {
            color: COLORS.text.hint,
            opacity: 1,
          },
        },
        
        ...sx,
      }}
      {...props}
    />
  );
};

export default StyledTextField;
